import React from 'react';

import styles from './MobileOrderDelivery.module.css'
import {Button} from "../../../../../ui/General/Button/Button.tsx";
import {MobileDeliveryPickup} from "./components/MobileDeliveryPickup/MobileDeliveryPickup.tsx";
import {DeliveryMethods} from "./components/MobileDeliveryMethod/DeliveryMethods.tsx";
import {MobileDeliveryByCompanies} from "./components/MobileDeliveryByCompanies/MobileDeliveryByCompanies.tsx";
import { DeliveryType} from "../../../../../types/Delivery.interface.ts";
import {Order} from "../../../../../types/Order.interface.ts";

interface Props {
    offer: Order,
}


export const MobileOrderDelivery: React.FC<Props> = ({
                                                        offer,
                                                    }) => {
    const city = {id: offer.delivery.townId, name: offer.delivery.townName};
    const deliveryType = offer.delivery.type;
    const isPodzamenuPickup = deliveryType === DeliveryType.pickup
    const isOthers = deliveryType === DeliveryType.shipping;

    return (
        <div className={styles.wrapper}>
            <h2 className={styles.title}>1. Где и как вы хотите получить заказ?</h2>
            <div className={styles.main}>
                {
                    isOthers
                        ? <>
                            <div className={styles.cityWrapper}>
                                <div className={styles.cityLabelWrapper}>
                                    <div className={styles.cityLabel}>Ваш город:</div>
                                    <Button className={styles.btnCityLabel} type='text'>Изменить</Button>
                                </div>
                                <div className={styles.city}>
                                    {city.name}
                                </div>
                            </div>
                            {/*<div className={styles.outline}/>*/}
                            {/*<div className={styles.cityWrapper}>*/}
                            {/*    <div className={styles.cityLabelWrapper}>*/}
                            {/*        <div className={styles.cityLabel}>Отправка из ПВ</div>*/}
                            {/*    </div>*/}
                            {/*    <div className={styles.city}>*/}
                            {/*        {offer.delivery.point.address}*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </>
                        : null
                }
                <div className={styles.outline}/>
                <h3 className={styles.mainTitle}>Выберите способ получения заказа</h3>
                <DeliveryMethods deliveryType={deliveryType} offer={offer}/>

                {
                    isPodzamenuPickup
                        ? <MobileDeliveryPickup offer={offer}/>
                        : null
                }

                {
                    isOthers
                        ? <MobileDeliveryByCompanies offer={offer}/>
                        : null
                }
            </div>
        </div>
    );
};